import { MutableRefObject, useEffect, useRef } from "react";
import DomHandler from "../WSUtils/DomHandler";

/**
 * Uses custom DOMHandler.absolutePosition to prevent overlay panel from appearing outside
 * of the viewport and causing window scroll
 */
export const useCustomAlignOverlay = (
  getParentElement: (t) => any,
  ref?: MutableRefObject<any>
) => {
  if (!ref) ref = useRef(null);

  useEffect(() => {
    if (!ref.current) return;

    ref.current.alignOverlay = function () {
      DomHandler.alignOverlay(
        this.overlayRef.current,
        getParentElement(this),
        this.props.appendTo || null
      );
    };
  });

  return ref;
};

export const useCustomAlignDropdownOverlay = (ref?: MutableRefObject<any>) => {
  return useCustomAlignOverlay((t) => t.input.parentElement, ref);
};

export const useCustomAlignTreeSelectOverlay = (
  ref?: MutableRefObject<any>
) => {
  return useCustomAlignOverlay((t) => t.trigger.parentElement, ref);
};

export const useCustomAlignMultiSelectOverlay = (
  ref?: MutableRefObject<any>
) => {
  return useCustomAlignOverlay((t) => t.label.parentElement, ref);
};
